<template>
	<div>
		<h1>Profilom</h1>
		<v-simple-table>
			<tbody>
				<tr>
					<th>Név</th>
					<td>{{nev}}</td>
					<td>
						<v-btn
							color="blue"
							@click="dialogus.megjelenik = true, dialogus.modositandoertek=0, dialogus.modositottertek=nev"
						>
							Módosítás<v-icon>fa-edit</v-icon>
						</v-btn>
					</td>
				</tr>
				<tr>
					<th>Email</th>
					<td>{{email}}</td>
					<td>
						<v-btn
							color="blue"
							@click="dialogus.megjelenik = true, dialogus.modositandoertek=1, dialogus.modositottertek=email"
						>
							Módosítás<v-icon>fa-edit</v-icon>
						</v-btn>
					</td>
				</tr>
				<tr>
					<th>Jelszó</th>
					<td>TITOK</td>
					<td>
						<v-btn
							color="blue"
							@click="dialogus.megjelenik = true, dialogus.modositandoertek=2, dialogus.modositottertek=''"
						>
							Módosítás<v-icon>fa-edit</v-icon>
						</v-btn>
					</td>
				</tr>
			</tbody>
		</v-simple-table>
		<template>
		  <v-row justify="center">
		    <v-dialog
		      v-model="dialogus.megjelenik"
		      persistent
		      max-width="600px"
		    >

		      <v-card>
		        <v-card-title>
		          <span class="headline">{{dialogus.modositandoertek ==0? "Név" : (dialogus.modositandoertek == 1 ? "Email-cím" : (dialogus.modositandoertek==2 ? "Jelszó" : (dialogus.modositandoertek==3 ? "Iskola" : "Sport")))}} módosítása</span>
		        </v-card-title>
		        <v-card-text>
		          <v-container>
		            <v-text-field
									v-model="dialogus.modositottertek"
									:label="dialogus.modositandoertek ==0? 'Név' : (dialogus.modositandoertek == 1 ? 'Email-cím' : (dialogus.modositandoertek==2 ? 'Új jelszó' : (dialogus.modositandoertek==3 ? 'Iskola' : 'Sport')))"
									:prepend-inner-icon="dialogus.modositandoertek ==0? 'fa-user' : (dialogus.modositandoertek == 1 ? 'fa-envelope' : (dialogus.modositandoertek==2 ? 'fa-lock' : (dialogus.modositandoertek==3 ? 'fa-school' : 'fa-baseball-ball')))">
								</v-text-field>
								<v-text-field v-model="dialogus.jelszo" type="password" prepend-inner-icon="fa-lock" label="Régi jelszó"></v-text-field>
		          </v-container>
		        </v-card-text>
		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn
		            color="blue darken-1"
		            text
		            @click="dialogus.megjelenik = false"
		          >
		            Mégsem
		          </v-btn>
		          <v-btn
		            color="blue darken-1"
		            text
		            @click="modositas()"
		          >
		            Módosítás
		          </v-btn>
		        </v-card-actions>
		      </v-card>
	    </v-dialog>
	  </v-row>
		<v-snackbar
		 v-model="snackbar.megnyit"
		>
		 {{ snackbar.szoveg }}
		 <v-btn
			 color="pink"
			 text
			 @click="snackbar.megnyit = false"
		 >
			 Bezár
		 </v-btn>
		</v-snackbar>
	</template>
		<!--<v-row>
			<v-col>
				<v-text-field label="Név" v-model="nev"></v-text-field>
			</v-col>
			<v-col>
				<v-text-field label="Email" v-model="email"></v-text-field>
			</v-col>
			<v-col>
				<v-text-field label="Jelszó" type="password" autocomplete="off" v-model="jelszo"></v-text-field>
			</v-col>
			<v-col>
				<v-text-field label="Jelszó mégegyszer" type="password" autocomplete="off" v-model="jelszoismetles"></v-text-field>
			</v-col>
		</v-row>-->
	</div>
</template>

<script>
	import router from '../router';
	export default {
		data: function(){
			return {
				nev: '',
				email: '',
				dialogus: {
					megjelenik: false,
					modositandoertek: 0,
					modositottertek: "",
					jelszo: ""
				},
				snackbar:{
	  			szoveg:"",
	  			megnyit:false
	  		}
			}
		},
		computed: {

		},
		watch: {

		},
		methods: {
				modositas: function() {
					console.log(this)
					this.axios.post(this.$store.state.backendeleres+"profil",{modositandoertek: this.dialogus.modositandoertek, modositottertek: this.dialogus.modositottertek, jelszo: this.dialogus.jelszo})
										.then((response) => {
											this.snackbar.szoveg = response.data.ok ? "A módosítás sikeresen megtörtént." : "Hiba a módosítás során: "+response.data.hiba;
											this.snackbar.megnyit=true;
											if(response.data.ok) {
												this.dialogus.megjelenik=false;
											}
										})
				}
		},
		mounted(){
			this.axios.get(this.$store.state.backendeleres+"profil").then((response) => {
				if(response.data.ok){
					this.nev=response.data.nev;
					this.email=response.data.email;
				}
			})
		}
	}
</script>
